<div [ngClass]="{ 'is-collapsed': isCollapse }" class="app">
  <div [ngClass]="headerSelected" class="layout">
    <div [ngClass]="sidenavSelected">
      <!-- Side Nav START -->
      <app-side-nav></app-side-nav>
      <!-- Side Nav END -->

      <!-- Page Container START -->
      <div class="page-container">
        <!-- Top Nav START -->
        <app-header></app-header>
        <!-- Top Nav END -->

        <!-- Content Wrapper START -->
        <div class="main-content">
          <div class="elevation-background"></div>
          <router-outlet></router-outlet>
        </div>
        <!-- Content Wrapper END -->

        <!-- Footer START -->
        <app-footer></app-footer>
        <!-- Footer END -->
      </div>
      <!-- Page Container END -->
    </div>
  </div>
</div>
